import { useCallback, useEffect, useState } from "react";
import { Link2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const SendPayLinkButton = ({ loanId, refreshKey, onSent }) => {
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get(`/loans/${loanId}/pay-link`).then((r) => setState(r.data)).catch(() => setState(null)), [loanId]);
  useEffect(() => { load(); }, [load, refreshKey]);

  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/loans/${loanId}/pay-link`);
      (data.status === "Sent" ? toast.success : toast.error)(data.message, { id: "pay-link-result" });
      onSent?.();
    } catch (e) {
      toast.error(apiError(e).message, { id: "pay-link-result" });
    } finally {
      setBusy(false);
    }
  };

  const disabled = !state?.can_send;
  return (
    <span className="inline-flex flex-col items-start" title={disabled ? state?.reason || "" : ""}>
      <Button variant="outline" onClick={send} disabled={disabled || busy} data-testid="send-pay-link-button">
        {busy ? <Loader2 className="animate-spin" /> : <Link2 />} Send pay link
      </Button>
      {state && disabled && <span className="mt-1 text-xs text-muted-foreground" data-testid="send-pay-link-disabled-reason">{state.reason}</span>}
    </span>
  );
};
